export interface ErrorResponse {
  error_message: string;
}

export class NonSuccessResponse extends Error {
  code: string;
  constructor(message: string, code: string | number) {
    super(message);
    this.name = "NonSuccessResponse";
    this.code = code + "";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class RedirectResponse extends NonSuccessResponse {
  targetUrl: string;
  constructor(targetUrl: string) {
    super("", "303");
    this.message = "";
    this.targetUrl = targetUrl;
    this.name = "RedirectResponse";
  }
}
